import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';

export default class ScramjetPuHandler extends WebComponent {
    didMount() {
      const self = this;
      window.setTimeout(function(){
        const alert = self.element.querySelector('.alert');
        const espContainer = $('.esp-fixed-container');
        const espScramjet = $('.esp-scramjet');
        const formGroupError = $('.form-group.has-error');
        const bodyOffset = 100;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const anchorId = urlParams.get('anchorId');
        if (alert && !anchorId) {
          if (espContainer.length && espScramjet.length) {
            espContainer.animate({ scrollTop: 0 }, 200);
          } else {
            $('html, body').animate({ scrollTop: $(alert).eq(0).offset().top - bodyOffset }, 200);
          }
        } else if(formGroupError.length) {
          if (espContainer.length && espScramjet.length) {
            espContainer.animate({ scrollTop: formGroupError.eq(0).position().top }, 200);
          } else {
            $("html, body").animate({ scrollTop: formGroupError.eq(0).offset().top - bodyOffset }, 200);
          }
        }
      },200);
    }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ScramjetPuHandler.js